export default "__VITE_ASSET__8KxNxZSe__"